export default __webpack_public_path__ + "static/media/office1-after1-1024w.af29d6e9.png";